import React from "react";

/**
 * Generic error modal used app-wide for any backend/validation failure.
 * isOpen    - whether the modal is visible
 * message   - the error text to display
 * onClose   - called when the user taps the Close button (or the backdrop)
 * title     - optional heading, defaults to a generic one
 */
const ErrorModal = ({ isOpen, message, onClose, title = "Something went wrong" }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />

      <div className="relative w-full bg-white rounded-t-2xl sm:rounded-2xl flex flex-col animate-slide-up sm:max-w-sm sm:mx-auto shadow-lg overflow-hidden">
        <div className="px-6 pt-7 pb-6 flex flex-col items-start text-left">
          <h3 className="text-lg font-semibold text-black">{title}</h3>
          <div className="w-full border-t border-gray-200 my-3" />
          <p className="text-base text-gray-500 leading-relaxed">{message}</p>
        </div>

        <button
          onClick={onClose}
          className="w-full py-3.5 border-t border-gray-200 font-semibold text-base text-black active:bg-gray-50 transition-colors"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ErrorModal;